'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var legend = {
    layout: 'vertical',
    align: 'center',
    verticalAlign: 'middle',
    name: '',
    labelFormatter: function () {
        // eslint-disable-next-line react/no-this-in-sfc
        return "" + this.name;
    },
    itemStyle: {
        fontSize: '17px',
        fontWeight: '400',
    },
    symbolHeight: 12,
    symbolRadius: 6,
    itemMarginBottom: 10,
};

exports.legend = legend;
